import {
  EllipsisWithTooltip,
  Typography,
  Box,
  Stack,
} from '@cast/design-system';

import { CopyToClipboard } from 'components/clickable-actions';

type Props = {
  value?: string | null;
  showCopy?: boolean;
};

export const NodeDetailsWithTooltip = ({ value, showCopy = true }: Props) => {
  return (
    <Stack direction="row" gap={8} alignItems="flex-start">
      <Box maxWidth={156} component="span">
        <EllipsisWithTooltip
          TooltipProps={{
            title: (
              <Stack direction="row" alignItems="center" gap="4px">
                <CopyToClipboard text={value!} color="#fff" iconSize="14px" />

                <Typography variant="P12R">{value || '-'}</Typography>
              </Stack>
            ),
            arrow: true,
            placement: 'top',
            leaveDelay: 100,
          }}
          TypographyProps={{ variant: 'P14R' }}
        >
          {value || '-'}
        </EllipsisWithTooltip>
      </Box>
      {!!value && showCopy && (
        <CopyToClipboard
          text={value}
          iconSize={16}
          sx={{ transform: 'translateY(2px)' }}
        />
      )}
    </Stack>
  );
};
